import * as types from './actionTypes';

export function loadSystemInfoSuccess(systemInfo: any) {
    return { type: types.LOAD_SYSTEM_INFO_SUCCESS, systemInfo };
}
